import { HeroSection } from "@/components/sections/HeroSection"
import { AdmissionsFlyerSection } from "@/components/sections/AdmissionsFlyerSection"
import { ValuesSection } from "@/components/sections/ValuesSection"
import { PathwaySection } from "@/components/sections/PathwaySection"
import { InternationalSection } from "@/components/sections/InternationalSection"
import { AudienceSection } from "@/components/sections/AudienceSection"
import { CTASection } from "@/components/sections/CTASection"

function ImageBreak() {
  return (
    <section className="py-16 bg-ivory">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Image 8: Single reflective pause - community, unity, closing tone */}
        <div className="aspect-[3/1] overflow-hidden rounded-lg">
          <img 
            src="/images/who-we-serve.jpg" 
            alt="" 
            className="w-full h-full object-cover object-top"
            aria-hidden="true"
          />
        </div>
        {/* Football action gallery */}
        <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4">
          <img src="/images/gallery-1.jpg" alt="Football training" className="rounded-lg shadow-md hover:shadow-lg transition-shadow" />
          <img src="/images/gallery-2.jpg" alt="Football teamwork" className="rounded-lg shadow-md hover:shadow-lg transition-shadow" />
          <img src="/images/gallery-3.jpg" alt="Football skills" className="rounded-lg shadow-md hover:shadow-lg transition-shadow" />
          <img src="/images/gallery-4.jpg" alt="Football victory" className="rounded-lg shadow-md hover:shadow-lg transition-shadow" />
        </div>
      </div>
    </section>
  )
}

export function HomePage() {
  return (
    <>
      <HeroSection />
      <AdmissionsFlyerSection />
      <ValuesSection />
      <PathwaySection />
      <InternationalSection />
      <AudienceSection />
      
      {/* Single image pause before CTA - reflective, not decorative */}
      <ImageBreak />
      
      <CTASection />
    </>
  )
}
